import { MapContainer, TileLayer, Polygon, Tooltip, useMap } from 'react-leaflet';
import L from 'leaflet';
import { useEffect } from 'react';

const AutoFitBounds = ({ polygons, disabled = false, onFit }) => {
    const map = useMap();

    useEffect(() => {
        if (disabled || !polygons || polygons.length === 0) return;

        const allCoords = polygons.flatMap(p => p.coordinates);
        const bounds = L.latLngBounds(allCoords);
        map.fitBounds(bounds, { padding: [50, 50] });

        if (onFit) onFit();
    }, [polygons]);

    return null;
};

export default AutoFitBounds;
